/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { ICommerceWebModuleData } from './commerce-web-module.data';
import { ICommerceWebModuleProps } from './commerce-web-module.props.autogenerated';
import App from './App';

export interface ICommerceWebModuleViewProps extends ICommerceWebModuleProps<ICommerceWebModuleData> {}

/**
 *
 * CommerceWebModule component
 * @extends {React.PureComponent<ICommerceWebModuleProps<ICommerceWebModuleData>>}
 */
class CommerceWebModule extends React.PureComponent<ICommerceWebModuleProps<ICommerceWebModuleData>> {
    public render(): JSX.Element | null {
        return <App />;
    }
}

export default CommerceWebModule;
